export enum FAVORITE_ACTION {
  ADD_FAVORITE = 'add_favorite',
  REMOVE_FAVORITE = 'remove_favorite',
}
